import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useLocalDayKey } from "@-/dev.improve.haniverse.lib.time.local-day";
import { DeckLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.deck._context";
import {
  DeckCardSurface,
  DeckCardSurfaceScrollView,
} from "@-/dev.improve.haniverse.routes.nav.app.deck._components.deck-card-section.surface";
import { useLayoutEffect, useMemo } from "react";
import { useDeckUpcomingPageModelSuspense } from "#use-deck-upcoming-page-model-suspense";

/** Every overdue review and every review scheduled before the next local midnight. */
export function DeckTodayView() {
  const todayKey = useLocalDayKey();
  const selection = useMemo(() => ({ date: new Date(`${todayKey}T00:00:00`) }), [todayKey]);
  const model = useDeckUpcomingPageModelSuspense({ selection });
  const [displayMode, setDisplayMode, setViewDisplayMode] = useContextSelectors(
    DeckLayoutContext,
    (c) => c.displayMode,
    (c) => c.setDisplayMode,
    (c) => c.setViewDisplayMode,
  );
  const defaultDisplayMode =
    model.selected.cardCount < 16 ? "morpheme-details-tiles" : "morpheme-glyph-tiles";
  useLayoutEffect(() => {
    setViewDisplayMode(defaultDisplayMode);
    return () => setViewDisplayMode(null);
  }, [defaultDisplayMode, setViewDisplayMode]);
  return (
    <DeckCardSurfaceScrollView testID="deck-today-scroll">
      <DeckCardSurface
        bodyKey="deck-today-reviews"
        cardCount={model.selected.cardCount}
        coreSliceByFront={model.coreSliceByCharacter}
        countLabel="Reviews"
        displayMode={displayMode}
        emptyMessage="No reviews due today."
        fronts={model.selected.fronts}
        onToggleDetails={() =>
          setDisplayMode(
            displayMode === "morpheme-details-tiles"
              ? "morpheme-glyph-tiles"
              : "morpheme-details-tiles",
          )
        }
        stageByFront={model.stageByCharacter}
        subtitle={
          model.selected.quizCount > 0
            ? `Due now or later today · Includes ${model.selected.quizCount} quizzes`
            : "Due now or later today"
        }
        tilesByFront={model.selected.tilesByFront}
        title="Today"
      />
    </DeckCardSurfaceScrollView>
  );
}
